export default __webpack_public_path__ + "static/media/check.c863b591.svg";